function readBooleanFlag(value: string | undefined, defaultValue: boolean): boolean {
  if (value === "true") return true;
  if (value === "false") return false;
  return defaultValue;
}

function readOpenAiConsent(value: string | undefined): "granted" | "denied" {
  return value === "granted" ? "granted" : "denied";
}

export const conversionTrackingConfig = Object.freeze({
  ga4Enabled: readBooleanFlag(process.env.NEXT_PUBLIC_TRACKING_GA4_ENABLED, true),
  ga4MeasurementId: process.env.NEXT_PUBLIC_G_ID?.trim() ?? "",
  metaPixelEnabled: readBooleanFlag(process.env.NEXT_PUBLIC_TRACKING_META_PIXEL_ENABLED, true),
  metaCapiEnabled: readBooleanFlag(process.env.NEXT_PUBLIC_TRACKING_META_CAPI_ENABLED, true),
  openaiPixelEnabled: readBooleanFlag(process.env.NEXT_PUBLIC_TRACKING_OPENAI_PIXEL_ENABLED, false),
  openaiPixelId: process.env.NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID?.trim() ?? "",
  openaiDebug: readBooleanFlag(process.env.NEXT_PUBLIC_OPENAI_ADS_DEBUG, false),
  openaiConsent: readOpenAiConsent(process.env.NEXT_PUBLIC_OPENAI_ADS_CONSENT),
});
